//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BoundingObjectBuilderList.js";
import "../no/SelectPointList.js";
import "../no/SelectCurve.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
import "../no/ObjectList.js";
let d=[[[0,"ArcLength",1,0],[1,"BoundingObjects",0,"GeometricUtilities.BoundingObjectBuilderList",0],[0,"CornerMethod",1,0],[0,"CornerNumber",1,0],[1,"CornerPoint",0,"SelectPointList",0],[0,"DirectionFlag",1,0],[1,"DividingCurve",0,"SelectCurve",0],[0,"EqualArcLengthSegments",1,0],[0,"EqualParameterSegments",1,0],[0,"EqualSegmentMethod",1,0],[1,"KnotPoint",0,"SelectPointList",0],[0,"KnotPointMethod",1,0],[0,"KnotPointNumber",1,0],[0,"Type",1,0]],[],[]];
SPLM.Features.DivideCurveBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DivideCurveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DivideCurveBuilder.EqualSegmentOption = Object.freeze({
    "EqualParameter" : "EqualParameter", "EqualArcLength" : "EqualArcLength"});

SPLM.Features.DivideCurveBuilder.InputArcLengthDirectionFlag = Object.freeze({
    "Start" : "Start", "End" : "End"});

SPLM.Features.DivideCurveBuilder.KnotPointOption = Object.freeze({
    "ByNumber" : "ByNumber", "SelectPoint" : "SelectPoint", "AllKnotpoints" : "AllKnotpoints"});

SPLM.Features.DivideCurveBuilder.CornerOption = Object.freeze({
    "ByNumber" : "ByNumber", "SelectPoint" : "SelectPoint", "AllCornerpoints" : "AllCornerpoints"});

SPLM.Features.DivideCurveBuilder.Types = Object.freeze({
    "EqualSegments" : "EqualSegments", "ByBoundingObjects" : "ByBoundingObjects", "InputArcLengthSegments" : "InputArcLengthSegments", "AtKnotpoints" : "AtKnotpoints", "AtCorners" : "AtCorners"});

export default SPLM;